<template>
  <DialogLayout
    title="詳細検索"
    :visible.sync="dialogVisible"
    width="65em"
    @open="open"
    class="detail-search-dialog"
  >
    <template #form>
      <RegistrationSymbolMasterForm
        ref="registrationSymbolForm"
        v-model="registrationSymbolForm"
        label-width="10em"
        formMode="search"
        :autocomplete-registration-symbol-set="autocompleteRegistrationSymbolSet"
        :autocomplete-owner-code-set="autocompleteOwnerCodeSet"
        :autocomplete-model-code-set="autocompleteModelCodeSet"
      />
    </template>
    <template #footer>
      <SearchDialogFooter
        @clear="clickClear"
        @search="clickSearch"
      />
    </template>
 </DialogLayout>
</template>

<script>
import DialogLayout from '@/components/templates/DialogLayout.vue'
import RegistrationSymbolMasterForm from '@/components/organisms/dialog/master/RegistrationSymbolMasterForm.vue'
import SearchDialogFooter from '@/components/organisms/dialog/SearchDialogFooter.vue'

export default {
  components: {
    DialogLayout,
    RegistrationSymbolMasterForm,
    SearchDialogFooter
  },
  props: {
    model: Object,
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteOwnerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    visible: Boolean
  },
  data () {
    return {
      registrationSymbolForm: {
        registration_symbol: undefined,
        owner_code: undefined,
        search_base_date: undefined,
        model_code: undefined,
        aircraft_type: undefined,
        weight_1: undefined,
        noise_level_1: undefined,
        weight_2: undefined,
        noise_level_2: undefined,
        weight_3: undefined,
        noise_level_3: undefined,
        aircraft_attribute: undefined
      }
    }
  },
  computed: {
    dialogVisible: {
      get () {
        return this.visible
      },
      set (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  mounted () {
  },
  methods: {
    clickClear () {
      this.$refs.registrationSymbolForm.clearFields()
    },
    clickSearch () {
      this.$refs.registrationSymbolForm.validate()
        .then((valid) => {
          sessionStorage.setItem('registrationSymbolSearchCond', JSON.stringify(this.registrationSymbolForm))
          this.dialogVisible = false
          this.$emit('search', this.registrationSymbolForm)
        })
    },
    open () {
      const searchCond = JSON.parse(sessionStorage.getItem('registrationSymbolSearchCond'))
      this.$nextTick(() => {
        this.$refs.registrationSymbolForm.clearFields()
        if (searchCond) {
          Object.keys(this.registrationSymbolForm).forEach((x) => {
            this.$set(this.registrationSymbolForm, x, searchCond[x])
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-search-dialog {
  ::v-deep .el-form-item {
    &.remarks {
      display: none;
    }
  }
}
</style>
